
/**
 * Shimmer applies styles and animations to an element based on a few computations.
 * The first computation is whether the element is below-screen, on-screen or above-screen.
 */
export class Shimmer {
	constructor(e) {
		this.el = e;

		let k = Shimmer.findKeyframe(e.getAttribute(`data-keyframe`));
		if (!k) {
			console.log(`failed to find @keyframe ${e.getAttribute(`data-keyframe`)}`);
			return;
		}
		document.addEventListener(`scroll`, evt=>{
			this.scroll(evt);			
		}, { passive: true });
		document.addEventListener(`resize`, evt=>{
			this.apply();
		}, { passive: true });
		this.keyframes = new KeyframeEffect(this.el,
			k,
			{
				duration: 3000, 
				fill: `forwards`,
				repeat: 1,
				// easing: "none",
			}
  			);

		this.animate = new Animation(this.keyframes, document.timeline);
		this.animate.startTime = 0;
		this.animate.pause();
		this.animate.currentTime = 1500;
		this.apply();
	}

	/**
	 * Camelize a string, cutting the string by multiple separators like
	 * hyphens, underscores and spaces.
	 * 
	 * @param {text} string Text to camelize
	 * @return string Camelized text
	 */
	static camelize(text) {
	    return text.replace(/^([A-Z])|[\s-_]+(\w)/g, function(match, p1, p2, offset) {
	        if (p2) return p2.toUpperCase();
	        return p1.toLowerCase();        
	    });
	}
	/**
	 *  findKeyframe finds the last named keyframe sequence with the given
	 * name, and converts it to a keyframe format per 
	 * https://developer.mozilla.org/en-US/docs/Web/API/Web_Animations_API/Keyframe_Formats
	 */
	static findKeyframe(name) {
		let lastRule = null;
		for (let s of document.styleSheets) {
			for (let c of s.cssRules) {
				if (c.name==name && c.type==c.KEYFRAMES_RULE) {
					lastRule = c;
				}
			}
		}
		if (!lastRule) return null;
		// Convert lastRule into a Keyframe format
		let ks = [];
		for (let r of lastRule.cssRules) {
			let s = {};
			for (let i=0; i<r.style.length; i++) {
				let p = r.style[i];
				s[Shimmer.camelize(p)] = r.style.getPropertyValue(p);
			}
			let p = parseInt(r.keyText);
			s[`offset`] = p/100.0;
			ks.push(s);
		}
		console.log(`ks = `, ks);
		return ks;
	}
	// apply applies the computation and sets styles based on the computed computation.
	apply() {
		if (!this.el.classList.contains(`Shimmer`))
			this.el.classList.add(`Shimmer`);

		/*
		 * We are going to scale our animation through a range [0,1], such that 0 occurs when the bottom
		 * of the element passes off screen to the top, and 1 happens when the 
		 * TOP of the element passes off the bottom of the screen.
		 *
		 * So, in terms of the TOP of the element, we first find the element height:
		 */
		let r = this.el.getBoundingClientRect();
		/*
		 * Now 
		 *     height = r.height
		 * , and 
		 *     absTop = r.top + window.scrollY;
		 *
		 * So the bottom of the element passes off the top of the screen when 
		 * the absTop <= window.scrollY - height
		 *
		 * and the top of the element passes off the bottom of the screen when
		 * absTop > scrollY + top.innerHeight		 
		 */
		let yTop = r.top + window.scrollY;
		let yProp = (yTop - (window.scrollY - r.height)) / (top.innerHeight + r.height);
		yProp = 1-Math.min(Math.max(yProp, 0), 1);
		this.animate.currentTime = yProp * 3000;

	}
	scroll(evt) {
		this.apply();
	}
	static init() {
		for (let e of document.querySelectorAll(`[data-instance="Shimmer"]`)) {
			new Shimmer(e);
		}
	}
}